import { c as _c } from "react/compiler-runtime";
import { GRANULARITY_OPTIONS } from '@/modules/finances/types';
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import type { Option } from '@/modules/shared/components/form/multiselect';
interface GranularitySelectProps {
  granularity: GRANULARITY_OPTIONS | null;
  setGranularity: (granularity: GRANULARITY_OPTIONS) => Promise<URLSearchParams>;
  className?: string;
}
const granularityOptions: Option[] = [{
  value: GRANULARITY_OPTIONS.Monthly,
  label: GRANULARITY_OPTIONS.Monthly,
  group: 'Granularity'
}, {
  value: GRANULARITY_OPTIONS.Quarterly,
  label: GRANULARITY_OPTIONS.Quarterly,
  group: 'Granularity'
}, {
  value: GRANULARITY_OPTIONS.Annually,
  label: GRANULARITY_OPTIONS.Annually,
  group: 'Granularity'
}];
function BreakdownGranularitySelectDrawer(t0) {
  const $ = _c(5);
  const {
    granularity,
    setGranularity
  } = t0;
  let t1;
  if ($[0] !== setGranularity) {
    t1 = value => {
      setGranularity(value as GRANULARITY_OPTIONS);
    };
    $[0] = setGranularity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  const t2 = granularity ?? undefined;
  let t3;
  if ($[2] !== handleChange || $[3] !== t2) {
    t3 = <DrawerSelect value={t2} onChange={handleChange} label="Metrics" options={granularityOptions} />;
    $[2] = handleChange;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export { BreakdownGranularitySelectDrawer };